export default function () {

    return <div className="flex justify-center">
        <img src="/logo.png" className="w-32" />
    </div>
}